import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import RightArrow from 'src/components/atoms/RightArrow'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

type ButtonSize = 'fluid' | 'fill' | 'medium' | 'large'

type Props = {
  color?: string
  text: string
  size?: ButtonSize
  to: string
  arrow?: boolean
  outer?: boolean
}

type ButtonProps = {
  color: string
  size: string
}

type RightArrowWrapperProps = {
  color: string
  arrow: boolean
}

const COLOR = {
  red: '#ef5e4b',
  blue: '#22475d',
  white: '#ffffff'
}

const chooseColor = (color: string | undefined) => {
  if (color === 'red') {
    return COLOR.red
  } else if (color === 'blue') {
    return COLOR.blue
  } else if (color === 'white') {
    return COLOR.white
  } else {
    return COLOR.red
  }
}

const SIZE = {
  fluid: 'auto',
  fill: '100%',
  medium: '240px',
  large: '390px'
}

const chooseSize = (size: ButtonSize | undefined) => {
  if (size === 'fluid') {
    return SIZE.fluid
  } else if (size === 'fill') {
    return SIZE.fill
  } else if (size === 'medium') {
    return SIZE.medium
  } else if (size === 'large') {
    return SIZE.large
  } else {
    return SIZE.large
  }
}

const ColorButton: React.FC<Props> = ({
  color,
  size,
  text,
  arrow = true,
  to,
  outer,
  ...props
}) => {
  const ColorButtonElement = (
    <Button color={chooseColor(color)} size={chooseSize(size)} {...props}>
      <ButtonText color={chooseColor(color)}>{text}</ButtonText>
      <RightArrowWrapper arrow={arrow} color={chooseColor(color)}>
        <RightArrow />
      </RightArrowWrapper>
    </Button>
  )

  if (!to) {
    return ColorButtonElement
  }

  if (outer) {
    return (
      <OuterLink href={to} target="_blank">
        {ColorButtonElement}
      </OuterLink>
    )
  }

  return React.cloneElement(ColorButtonElement, { as: Link, to })
}

const Button = styled.div<ButtonProps>`
  background-color: ${({ color }) => color};
  width: ${({ size }) => size};
  // margin: auto;
  height: 60px;
  border-radius: 6px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
    height: 50px;
  }
`

const ButtonText = styled(Typography)`
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 60px;
  text-align: center;
  letter-spacing: 1.5px;
  color: ${({ color }) => (color === COLOR.white ? '#22475d' : '#ffffff')};
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    line-height: 50px;
    margin: auto;
  }
`

const RightArrowWrapper = styled.div<RightArrowWrapperProps>`
  position: absolute;
  right: 0;
  top: 18px;
  fill: ${({ color }) => (color === COLOR.white ? '#22475d' : '#ffffff')};
  display: ${({ arrow }) => (arrow ? 'inherit' : 'none')};
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    top: 12px;
  }
`

const OuterLink = styled.a`
  text-decoration: none;
`

export default ColorButton
